import React from 'react'
import PropTypes from 'prop-types'
import { styled } from '@mui/material/styles'
import MikeTooltip from '@mike/mike-shared-frontend/mike-tooltip/MikeTooltip'

const StyledRoot = styled('div')({
  display: 'flex',
  alignItems: 'center'
})

const StyledIcon = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(0.5),
  marginRight: theme.spacing(1)
}))

const StyledLongText = styled('div')({
  maxWidth: '25vw',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'table-cell',
  paddingRight: 8
})

const StyledBoldText = styled('div')({
  maxWidth: '25vw',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'table-cell',
  paddingRight: 8,
  fontWeight: 'bold'
})

const LongName = ({
  longName,
  icon: Icon = null,
  variant = 'default'
}: {
  longName: string
  icon?: React.ComponentType<any> | null
  variant?: 'default' | 'bold'
}) => {
  const TextComponent = variant === 'bold' ? StyledBoldText : StyledLongText

  return (
    <StyledRoot>
      {Icon && (
        <StyledIcon>
          <Icon />
        </StyledIcon>
      )}
      <MikeTooltip title={longName}>
        <TextComponent>{longName}</TextComponent>
      </MikeTooltip>
    </StyledRoot>
  )
}

LongName.propTypes = {
  icon: PropTypes.any,
  longName: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['default', 'bold'])
}

export default React.memo(LongName)
